import {FlexColumn, FlexItem, Frame, Heading, Label, Text} from '@forecast-it/design-system';
import React from 'react';
import {useIntl} from 'react-intl';
import styled from 'styled-components';
import {formatCustomFieldCurrencyLabel} from '../../../../data/currencyHelpers';
import {CustomFieldType, CustomFieldTypeLabelIds, EntityTypeLabels} from '../Constants';
import {CustomFieldDefinition} from '../types';

// DS Text never breaks inside a word, so a space-less Display Name or Key would run past the panel border.
const PanelContent = styled.div`
	overflow-wrap: anywhere;
`;

type CustomFieldDetailsSectionProps = {
	customFieldDefinition: CustomFieldDefinition;
};

const CustomFieldDetailsSection = (props: CustomFieldDetailsSectionProps): JSX.Element => {
	const {formatMessage} = useIntl();

	const {entityType, displayName, key, type, currencyCode} = props.customFieldDefinition;

	return (
		<Frame height={'fullHeight'} width={'xs'} customPadding={'600'}>
			<PanelContent data-cy="custom-field-details">
				<FlexColumn gap="l">
					<FlexItem>
						<Heading size={4}>{formatMessage({id: 'settings.custom-fields.custom_field_title'})}</Heading>
					</FlexItem>

					<FlexItem>
						<FlexColumn gap="l">
							<FlexItem>
								<Label>{formatMessage({id: 'settings.custom-fields.applies_to'})}</Label>
								<Text>{EntityTypeLabels[entityType]}</Text>
							</FlexItem>

							<FlexItem>
								<Label>{formatMessage({id: 'settings.custom-fields.displayName'})}</Label>
								<Text>{displayName}</Text>
							</FlexItem>

							<FlexItem>
								<Label>{formatMessage({id: 'settings.custom-fields.key'})}</Label>
								<Text>{key}</Text>
							</FlexItem>

							<FlexItem>
								<Label>{formatMessage({id: 'common.type'})}</Label>
								<Text>{formatMessage({id: CustomFieldTypeLabelIds[type]})}</Text>
							</FlexItem>

							{type === CustomFieldType.CURRENCY && currencyCode && (
								<FlexItem>
									<Label>{formatMessage({id: 'common.currency'})}</Label>
									<Text>{formatCustomFieldCurrencyLabel(currencyCode)}</Text>
								</FlexItem>
							)}
						</FlexColumn>
					</FlexItem>
				</FlexColumn>
			</PanelContent>
		</Frame>
	);
};

export default CustomFieldDetailsSection;
